// extracted by mini-css-extract-plugin
export default {"bio":"Bio_bio__Mo9V+"};